var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#CD2122",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09 Agreement Document") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09_Agreement_Document",
    "data-name": "09 Agreement Document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,3H16a2,2,0,0,0-2,2V8H11a2,2,0,0,0-2,2V56a2,2,0,0,0,2,2H32v2a1,1,0,0,0,1.6.8L37,58.25l3.4,2.55A1,1,0,0,0,42,60V58h6a2,2,0,0,0,2-2V53h3a2,2,0,0,0,2-2V5A2,2,0,0,0,53,3ZM32.875,44.673l-.394-1.137.994-.7a1,1,0,0,0,.382-.527l.35-1.149,1.207.018a1.157,1.157,0,0,0,.616-.2l.97-.728.97.728a1.057,1.057,0,0,0,.616.2l1.207-.018.35,1.149a1,1,0,0,0,.382.527l.994.7-.394,1.137a1,1,0,0,0,0,.654l.394,1.137-.994.7a.994.994,0,0,0-.382.529l-.35,1.147-1.207-.018a.945.945,0,0,0-.616.2l-.97.728-.97-.728a.985.985,0,0,0-.3-.152.234.234,0,0,1-.026,0,1.011,1.011,0,0,0-.279-.045h-.016l-1.207.018-.35-1.147a.994.994,0,0,0-.382-.529l-.994-.7.394-1.137A1,1,0,0,0,32.875,44.673ZM40,58l-2.4-1.8a1,1,0,0,0-1.2,0L34,58V50.842l1.1-.017,1.3.974a1,1,0,0,0,1.2,0l1.3-.974,1.1.017V58Zm8-2H42V48.57l1.284-.9a1,1,0,0,0,.371-1.145L43.128,45l.527-1.523a1,1,0,0,0-.371-1.145L41.956,41.4l-.469-1.54a1,1,0,0,0-.957-.709h-.015l-1.618.025L37.6,38.2a1,1,0,0,0-1.2,0l-1.3.974-1.618-.025H33.47a1,1,0,0,0-.957.709l-.469,1.54-1.328.933a1,1,0,0,0-.371,1.145L30.872,45l-.527,1.523a1,1,0,0,0,.371,1.145l1.284.9V56H11V10l37,0V56Zm5-5H50V10a2,2,0,0,0-2-2H16V5H53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,16H36a1,1,0,0,0,0-2H23a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,19H16a1,1,0,0,0,0,2H43a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,26H34a1,1,0,0,0,0-2H16a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,31h9a1,1,0,0,0,0-2H16a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,34H16a1,1,0,0,0,0,2H30a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,29H29a1,1,0,0,0,0,2H43a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,24H38a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,34H34a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.366,42.226l-3.65,2.989-.41-2.461a2,2,0,0,0-3.387-1.085L15.293,45.3a1,1,0,0,0,1.414,1.414l3.626-3.626.41,2.46a2,2,0,0,0,1.968,1.672,2.057,2.057,0,0,0,1.239-.426l3.684-3.015a1,1,0,0,0-1.268-1.548Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage4);
export default __webpack_public_path__ + "static/media/image_4.53cb3a1794ef240b17e8042fd937e8dd.svg";
export { ForwardRef as ReactComponent };